import BuyBox from "./buy-box";
import { getTournamentEntryPrice } from "../currency";
import pure from "./higher-order/pure";
import React from "react";
import { trackAddToCart, trackRemoveFromCart } from "../analytics";

export default class TournamentBuyBox extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onAddToCart = this.onAddToCart.bind(this);
    this.onEnter = this.onEnter.bind(this);
    this.onRemoveFromCart = this.onRemoveFromCart.bind(this);
  }

  onAddToCart(quantity, currency) {
    var { isGameBoard, tournament } = this.props;
    trackAddToCart(isGameBoard ? "Game Board" : "Tournament List", tournament, quantity, currency);
  }

  onEnter(quantity, currency) {
    var { isGameBoard, tournament, tournamentEnter } = this.props;
    tournamentEnter(tournament, quantity, currency, isGameBoard);
  }

  onRemoveFromCart(quantity, currency) {
    var { isGameBoard, tournament } = this.props;
    trackRemoveFromCart(isGameBoard ? "Game Board" : "Tournament List", tournament, quantity, currency);
  }

  render() {
    var { disabled, isGameBoard, myTickets, session, sessionShowLogin, tournament } = this.props;
    var successDetailsMessage = "Make picks for each race below!";
    if (!isGameBoard) {
      successDetailsMessage = "Make Picks Now";
    }
    return (
      <BuyBox
        badge={<TournamentCannotEnterBadge myTickets={myTickets} tournament={tournament} />}
        detailsUrl={"/tournaments/" + tournament.get("id")}
        disabled={disabled}
        enterError={tournament.get("enterError")}
        entering={tournament.get("entering")}
        isGameBoard={isGameBoard}
        isOpen={["canceled", "final", "running"].indexOf(tournament.get("status")) === -1}
        itemsPurchasedByUser={myTickets.size}
        itemsRemaining={tournament.get("remaining_entries")}
        maxItemsPerUser={tournament.get("max_tickets")}
        onAddToCart={this.onAddToCart}
        onEnter={this.onEnter}
        onRemoveFromCart={this.onRemoveFromCart}
        price={getTournamentEntryPrice(tournament)}
        session={session}
        sessionShowLogin={sessionShowLogin}
        successDetailsMessage={successDetailsMessage} />
    );
  }
}

var TournamentCannotEnterBadge = pure(function TournamentCannotEnterBadge({ myTickets, tournament }) {
  if (tournament.get("status") === "running") {
    return <InProgressBadge />;
  }
  if (tournament.get("max_tickets") - myTickets.size === 0) {
    return <MaxEntriesReachedBadge />;
  }
  if (tournament.get("remaining_entries") === 0) {
    return <GameIsFullBadge />;
  }
  return null;
});

var MaxEntriesReachedBadge = pure(function MaxEntriesReachedBadge() {
  return (
    <span className="badge badge--red">
      <i className="dw-blocked" />

      <span>
        Max entries reached.
      </span>
    </span>
  );
});

var GameIsFullBadge = pure(function GameIsFullBadge() {
  return (
    <span className="badge badge--red">
      <i className="dw-blocked" />

      <div>
        This game is full!
      </div>
    </span>
  );
});

var InProgressBadge = pure(function InProgressBadge() {
  return (
    <span className="badge badge--lime">
      <i className="dw-time-slot" />

      <div>
        This game is in progress!
      </div>
    </span>
  );
});
